import { Injectable } from '@angular/core';
import { _HttpClient } from '@delon/theme';

@Injectable()
export class SalesDocTransferService {
  constructor(private http: _HttpClient) {}

  url = 'api/SalesTransfers/GetOutstandingDocs?_silent=true';
  loading = false;

  private _outstandingDocs: any[] = [];
  get outstandingDocs() {
    return this._outstandingDocs;
  }
  set outstandingDocs(val: any[]) {
    this._outstandingDocs = val;
  }

  reload(docType: string, customerId: any, transferredDocIds: string[], dateFrom: Date, dateTo: Date, docFrom: string, docTo: string, transferToDocCode: string) {
    const params: any = {
        docType: docType,
        customerId: customerId,
        transferredDocIds: transferredDocIds,
        docDateFrom: dateFrom,
        docDateTo: dateTo,
        docCodeFrom: docFrom,
        docCodeTo: docTo,
        transferToDocCode: transferToDocCode
    };

    //if docType == CS then customerId can be 0
    if (params.docType && (params.docType === 'CS' ? params.docType === 'CS' : params.customerId)) {
      this.http.post(this.url, params).subscribe(res => {
        this.outstandingDocs = [...res];
      });
    }
    else {
      this.outstandingDocs = [];
    }
  }
}
